// extracted by mini-css-extract-plugin
module.exports = {"mainSection":"MainSection_mainSection__10ChR","title":"MainSection_title__1VHIr"};